import TrustBanner from './TrustBanner'

export default TrustBanner
